import React, { Component } from 'react';
import Axios from 'axios';

import './Dashboard.css';
import PostList from './PostList';

class Dashboard extends Component {

    // constructor(props){
    //     super(props);
    //     this.state = {
    //         users: []
    //     }
    // }
    // ----- or --------
    state = {
        users: [],
        selectedUser: null
    }

    componentDidMount() {
        Axios.get("https://jsonplaceholder.typicode.com/users")
        .then((result) => {
            console.log(result);

            this.setState({
                users: result.data,
                selectedUser: result.data[0]
            });
        });
    }

    changeSelectedUser = (user) => {
        this.setState({ selectedUser: user },
            console.log(user));
    }

  render() {
      const { users, selectedUser } = this.state;
    return (
      <>
      <h2 className="ui piled header segment">
        <i className="ui pink inverted circular users icon"></i>
        <div className="content ui violet inverted header">
        Dashboard
        </div>
      </h2>
  
        <div className="ui vertically raised divided grid">
          <div className="two column row">
          { users.length === 0
            ? (<div>
                <div className="ui active inverted dimmer">
                <div className="ui medium text loader">Loading Users</div>
                </div>
                </div>)
            : (<div className="column ui vertical pointing menu">
                { users.map((user, index) => {
                    return <div 
                    className={`ui middle aligned animated selection list ${user.id === selectedUser.id ? "item active" : ""}`}
                    key={user.id}
                    onClick={() => {
                    this.changeSelectedUser(user)
                    }}
                    >
                    <div className="ui tiny images header item">
                        <img src={`https://i.pravatar.cc/150?img${user.id}`} className="ui rounded image" alt="Avatar" />
                        <div className="content">
                            <h4 className="ui image header">
                                <div className="content contentList">
                                { user.name }
                                <div className="sub header">Human Resources</div>
                                </div>
                            </h4><hr/>
                        </div>
                    </div>
                    </div>
                    })}
                </div>
                )
            }
            <div className="column">
                {selectedUser !== null &&
                <PostList
                user={selectedUser}
                />
                }
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Dashboard;
